export type MachineStatus =
  | 'en_service'
  | 'hors_service'
  | 'en_maintenance'
  | 'en_panne';

export const MACHINE_STATUS_LABELS: Record<MachineStatus, string> = {
  en_service: 'En service',
  hors_service: 'Hors service',
  en_maintenance: 'En maintenance',
  en_panne: 'En panne',
};

export interface Machine {
  id: number;
  code: string;
  name: string;
  atelier_id: number;
  status: MachineStatus;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string;
  atelier_name?: string;
}

export interface MachineCreate {
  name: string;
  atelier_id: number;
  status?: MachineStatus;
}

export interface MachineUpdate {
  name?: string;
  atelier_id?: number;
  status?: MachineStatus;
}

export interface MachineListResponse {
  items: Machine[];
  total: number;
}

export interface MachineDropdownItem {
  id: number;
  code: string;
  name: string;
  status: MachineStatus;
}

export interface MachineConflictEntry {
  id: number;
  projet_code?: string;
  service_code?: string;
  responsables?: { id: number; full_name?: string; email?: string }[];
  date: string;
  start_time: string;
  end_time: string;
}

export interface MachineConflictResponse {
  has_conflict: boolean;
  conflicting_entries: MachineConflictEntry[];
}

/** A time slot keeping a machine busy (Gestion Planning entry or Comptoir étape). */
export interface MachineSlot {
  machine_id: number;
  source: 'planning' | 'comptoir';
  debut: string;
  fin: string;
  reference: string | null;
  libelle: string | null;
  depasse?: boolean; // time is over but not marked Terminé: still keeps the machine busy
}

/** GET /api/machines/occupation: keyed by machine id, only machines with a slot. */
export type MachineOccupation = Record<string, { actuelle: MachineSlot | null; prochaine: MachineSlot | null; non_termines: number }>;
